import React from 'react';

import S from './AppStore.module.css';

export const AppStoreImg = () => (
  <div className={S.root}>
    <div className={S.kirpich}>
      <div className={S.pen1}></div>
      <div className={S.pen2}></div>
    </div>
    <div className={S.glow}>
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
    </div>
  </div>
);
